import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import only_notes from '../../assets/images/only_notes.svg';
import full_conversation from '../../assets/images/full_conversation.svg';
import full_conversation_bottom from '../../assets/images/full_conversation_bottom.svg';

class ConversationFilterItem extends React.Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.props.onClick(this.props.value);
  }

  render() {
    let item = (
      <NavLink to={this.props.path} className="dropdown-menu__item">
        {this.props.label}
      </NavLink>
    );

    const itemProps = {
      onClick: this.onClick,
    };

    if (this.props.type === 'BUTTON') {
      item = (
        <div
          className={classnames('dropdown-menu__item', this.props.className)}
          {...itemProps}
        >
        <div className="dropdown-menu__item_element">
            <div className="dropdown-menu__item_element_data">
                {this.props.value === 'NOTES_UPDATES'?
                (<div className="filter-logo"><img src={only_notes}/></div>):
                (<div className="filter-logo"> <img src={full_conversation}/><img className="second-img" src={full_conversation_bottom} /></div>)}
                <div className={classnames("name",{'active-filter':this.props.selectedOption===this.props.value})} >{this.props.label}</div>
            </div>
            {this.props.selectedOption===this.props.value&&<div><i className="material-icons">check</i></div>}
        </div>
        </div>
      );
    }

    return item;
  }
}

ConversationFilterItem.defaultProps = {
  label: '',
  path: '',
  type: 'LINK',
  onClick: () => {},
  value: '',
};

ConversationFilterItem.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  path: PropTypes.string,
  type: PropTypes.oneOf(['LINK', 'BUTTON']),
  onClick: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ConversationFilterItem;
